import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const AmountDueInput = observer(({ value, error, setAmountDueCallback }) => (
  <span>
    <input
      className="ransom-option"
      onChange={e => setAmountDueCallback(e.target.value)}
      type="text"
      name="amountDue"
      placeholder="amount due $"
      value={value}
    />
    {error ? <p className="ransom-option error">{error}</p> : null}
  </span>
));

AmountDueInput.propTypes = {
  value: PropTypes.string,
  error: PropTypes.string,
  setAmountDueCallback: PropTypes.func.isRequired,
};

export default AmountDueInput;
